import styles from "./styles.module.css";
import React from "react";

import { Facebook, Twitter, Whatssap } from '@/icons/index';

const TituloTag = (props) => {

    const {
        metadata = {},
        slug,
        related,
        description,
        name,
    } = { ...props }


    const backgroundImage = related && related.image && related.image[0]?.url ? related.image[0].url : undefined;

    return (
        <>
            <div className={`${styles['title-tag-container']}`}>
                {
                    backgroundImage ?
                        <>
                            <div className={`${styles['no-image']}`}>
                                <HeaderBackground name={name} metadata={metadata} description={description} slug={slug} related={related} backgroundImg={backgroundImage} />
                            </div>
                            <div className={`${styles['mobile-only']}`}>
                                <HeaderBackgroundMobile name={name} metadata={metadata} description={description} slug={slug} related={related} backgroundImg={backgroundImage} />
                            </div>
                        </>
                        :
                        <div>
                            <HeaderSimple name={name} metadata={metadata} description={description} related={related} />
                        </div>
                }

            </div>
        </>
    )
}

const HeaderSimple = ({ name, metadata, description, related }) => {

    return <>
        <h2 className={`${styles['title']}`}>{name}</h2>
        {metadata && metadata?.subtitleH2 && <h2 className={`${styles['subtitle']}`}>{metadata.subtitleH2}</h2>}
        <hr className={`${styles['divider']}`} />
        <div className={`${styles['description']}`} dangerouslySetInnerHTML={{ __html: description }} />
        <div className={`${styles['tags-content-no-image']}`}>
            {related?.tags?.map((tag, index) => {
                return (
                    <a key={`tag-${index}`} className={`${styles['tag-anchor']}`} target={"_blank"} href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/tags/${tag.slug}`}>{tag.name}</a>
                )
            })}
            {related?.manualTags?.map((tag, index) => {
                return (
                    <a key={`manualTag-${index}`} className={`${styles['tag-anchor']}`} target={"_blank"} href={tag.link}>{tag.name}</a>
                )
            })}
        </div>
    </>
}

const HeaderBackground = ({ name, metadata, description, slug, related, backgroundImg }) => {

    const styling = {
        backgroundImage: `url('${backgroundImg}')`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        boxShadow: 'inset 10px -251px 157px 37px rgb(0 0 0 / 30%)'
    }

    return <>
        <h1 className={`${styles['title']}`}>{name}</h1>
        {metadata.subtitleH2 && <h2 className={`${styles['subtitle']}`}>{metadata.subtitleH2}</h2>}
        <div className={`${styles['image-container']}`} style={styling}>
            <div className={`${styles['description-content']}`} >
                <div dangerouslySetInnerHTML={{ __html: description }}></div>
            </div>
            <div className={`${styles['social-media']}`}>
                <a className={`${styles['social-icon']} ${styles['facebook']}`} href={`https://www.facebook.com/sharer.php?u=${process.env.NEXT_PUBLIC_DOMAIN_URL}/tags/${slug}`}>
                    <Facebook className={`${styles["facebook-icon-width-custom"]}`}/>
                </a>
                <a className={`${styles['social-icon']} ${styles['twitter']}`} href={`http://twitter.com/share?url=${process.env.NEXT_PUBLIC_DOMAIN_URL}/tags/${slug}`}>
                    <Twitter className={`${styles["twitter-icon-width-custom"]}`}/>
                </a>
                <a className={`${styles['social-icon']} ${styles['whatsapp']}`} href={`https://api.whatsapp.com/send?text=Accede%20a%20esta%20noticia%20de%20El%20Litoral:%20${process.env.NEXT_PUBLIC_DOMAIN_URL}/tags/${slug}%3Futm_medium%3Dwhatsapp%20-%20Envianos%20tu%20noticia%20a:%20%2B5493426305344`}>
                    <Whatssap className={`${styles["icon"]}`}/>
                </a>
            </div>
            <div className={`${styles['tags-container']}`} >
                <h5 className={`${styles['related-tags-title']}`}>Tags Relacionados</h5>
                <div className={`${styles['tags-content']}`}>
                    {related?.tags?.map((tag, index) => {
                        return (
                            <a key={`tag-${index}`} className={`${styles['tag-anchor']}`} target={"_blank"} href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/tags/${tag.slug}`}>{tag.name}</a>
                        )
                    })}
                    {related?.manualTags?.map((tag, index) => {
                        return (
                            <a key={`manualTag-${index}`} className={`${styles['tag-anchor']}`} target={"_blank"} href={tag.link}>{tag.name}</a>
                        )
                    })}
                </div>
            </div>
        </div>
    </>
}

const HeaderBackgroundMobile = ({ name, metadata, description, slug, related, backgroundImg }) => {

    const styling = {
        backgroundImage: `url('${backgroundImg}')`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        boxShadow: 'inset 10px -251px 157px 37px rgb(0 0 0 / 30%)'
    }

    return <>
        <h1 className={`${styles['title']}`}>{name}</h1>
        <div className={`${styles['img-headermobile']}`} style={styling}></div>
        {metadata.subtitleH2 && <h2 className={`${styles['subtitle']}`}>{metadata.subtitleH2}</h2>}
        <div className={`${styles['image-container']}`} >
            <div className={`${styles['description-content']}`} >
                <div dangerouslySetInnerHTML={{ __html: description }}></div>
            </div>
            


            <div className={`${styles['tags-container']}`} >
                <h5 className={`${styles['related-tags-title']}`}>Tags Relacionados</h5>
                <div className={`${styles['tags-content']}`}>
                    {related?.tags?.map((tag, index) => {
                        return (
                            <a key={`tag-${index}`} className={`${styles['tag-anchor']}`} target={"_blank"} href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/tags/${tag.slug}`}>{tag.name}</a>
                        )
                    })}
                    {related?.manualTags?.map((tag, index) => {
                        return (
                            <a key={`manualTag-${index}`} className={`${styles['tag-anchor']}`} target={"_blank"} href={tag.link}>{tag.name}</a>
                        )
                    })}
                </div>
            </div>




            <div className={`${styles['social-media']}`}>
                <a className={`${styles['social-icon']} ${styles['facebook']}`} href={`https://www.facebook.com/sharer.php?u=${process.env.NEXT_PUBLIC_DOMAIN_URL}/tags/${slug}`}>
                    <Facebook className={`${styles["facebook-icon-width-custom"]}`}/>
                </a>
                <a className={`${styles['social-icon']} ${styles['twitter']}`} href={`http://twitter.com/share?url=${process.env.NEXT_PUBLIC_DOMAIN_URL}/tags/${slug}`}>
                    <Twitter className={`${styles["twitter-icon-width-custom"]}`}/>
                </a>
                <a className={`${styles['social-icon']} ${styles['whatsapp']}`} href={`https://api.whatsapp.com/send?text=Accede%20a%20esta%20noticia%20de%20El%20Litoral:%20${process.env.NEXT_PUBLIC_DOMAIN_URL}/tags/${slug}%3Futm_medium%3Dwhatsapp%20-%20Envianos%20tu%20noticia%20a:%20%2B5493426305344`}>
                    <Whatssap className={`${styles["icon"]}`}/>
                </a>
            </div>
            
        </div>
    </>
}
export default TituloTag;
